<div [ngStyle]="{'border': '1px solid' + appointmentSlotDetails.workOrderColor, 'border-top': '5px solid' + appointmentSlotDetails.workOrderColor}"
    id="pop-box_day_mechId" style="display: block; height:auto" #slotPosition>
    <div class="card-header border-bottom p-2" >
        <div class="d-flex align-items-center">
            <div class="tooltipSubheader mr-2">
                #{{appointmentSlotDetails.workOrderNo}}
            </div>
            <div class="licplate LPNo tooltipheader">
                {{appointmentSlotDetails.licensePlate}}
            </div>
            <img af-brand-logo data-type="BRAND" [data-code]="appointmentSlotDetails.brandCode" [ngbTooltip]="appointmentSlotDetails.brandCode"  tooltipClass="my-tooltip"
                class="{{appointmentSlotDetails.brandCode}}-icon common" class="brandicon mr-2" alt="" />
        </div>
    </div>
    <ul class="plannedetailbox">
        <li><span translate> lblPlannedTime </span> : {{ appointmentSlotDetails.totalHours }} hr</li>
        <li><span translate> lblDealersName </span> : {{ dealerName }}</li>
        <li><span translate> lblCustomer </span> : {{ appointmentSlotDetails.customerName }}</li>
        <li><span translate> lblTooltipMechanic </span> : {{ appointmentSlotDetails.mechanicName }}</li>
        <li><span translate> lblWoStatus </span> : {{ appointmentSlotDetails.workOrderStatus }}</li>
        <li *ngIf="groupedJobs.length > 0">
            <strong><span translate > lblJobDetail </span>: </strong>
            <ul>
                <li *ngFor="let job of groupedJobs">
                    <strong>{{ job.jobDescription }}</strong>

                    <ul *ngIf="job.details.length > 0">
                        <li *ngFor="let detail of job.details" class="li-list">
                            {{ detail.description }}
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</div>